<app-navbar></app-navbar>

<div class="terms-wrapper">
  <h2 class="fade-in">Terms and Conditions</h2>

  <h4 class="fade-in">NexGen Executive Coaching Academy</h4>
  <p class="fade-in">Last Updated: [Insert Date]</p>

  <section class="fade-in">
    <h3>1. Acceptance of Terms</h3>
    <p>By accessing or using NexGen Executive Coaching Academy website, platform, mobile app, or any related services, you agree to be bound by these Terms and Conditions. If you do not agree, you may not use the platform.</p>
  </section>

  <section class="fade-in">
    <h3>2. Program Structure & Use of the Platform</h3>
    <ul>
      <li>NexGen Executive Coaching Academy provides a self-paced, hybrid learning model ...</li>
      <li>Students are responsible for tracking their own progress...</li>
      <li>Instructors are responsible only for delivering live webinars...</li>
      <li>Quizzes, modules, and exercises are self-guided...</li>
    </ul>
  </section>

  <section class="fade-in">
    <h3>3. Certification Disclaimer</h3>
    <ul>
      <li>Completion of NexGen Executive Coaching Academy program does not guarantee ICF certification...</li>
      <li>Students are solely responsible for maintaining logs...</li>
    </ul>
  </section>

  <section class="fade-in">
    <h3>4. Payment & Refund Policy</h3>
    <ul>
      <li>All purchases are final unless otherwise stated.</li>
      <li>Refund within 7 days if no material accessed.</li>
      <li>Upgrades are non-refundable once activated.</li>
    </ul>
  </section>

  <section class="fade-in">
    <h3>5. Account Access & Use</h3>
    <ul>
      <li>Students must keep their login credentials secure...</li>
      <li>NexGen Executive Coaching Academy may suspend access for any misuse...</li>
    </ul>
  </section>

  <section class="fade-in">
    <h3>6. Intellectual Property</h3>
    <ul>
      <li>All materials are the property of NexGen Executive Coaching Academy and may not be reused...</li>
    </ul>
  </section>

  <section class="fade-in">
    <h3>7. Technology Disclaimer</h3>
    <ul>
      <li>NexGen Executive Coaching Academy is not liable for third-party outages or app errors.</li>
    </ul>
  </section>

  <section class="fade-in">
    <h3>8. Changes to Terms</h3>
    <ul>
      <li>Terms may be updated at any time. Check the website regularly.</li>
    </ul>
  </section>

  <section class="fade-in">
    <h3>9. Contact Us</h3>
    <p>For any questions about these Terms and Conditions, please contact:</p>
  </section>
</div>

<app-footer></app-footer>
